import { useState } from "react";
import { AdaptedButton } from "../../components/adaptedButton";
import { StyleSheet, View } from "react-native";

export function Page16({ handleClick }) {
  const [selectedValues, setSelectedValues] = useState([]);
  const handleButtonClick = (name, value) => {
    const newSelectedValues = [...selectedValues];
    const valueIndex = newSelectedValues.indexOf(value);
    if (valueIndex === -1) {
      // Add value to selected values
      newSelectedValues.push(value);
    } else {
      // Remove value from selected values
      newSelectedValues.splice(valueIndex, 1);
    }
    setSelectedValues(newSelectedValues);
    handleClick(name, newSelectedValues);
  };
  return (
//foam, oil gel
//exfoiliants
//toners
//serum
//essence
//ampoule
//masks
//lotion
//moisturizer
//SPF

<View>
  <View style={styles.buttonRow}>
    <View style={styles.fix}>
      <AdaptedButton
        handleClick={handleButtonClick}
        field={'current_products'}
        fieldValue={'Oil cleanser'}
        selected={selectedValues.includes('Oil cleanser')}
      />
    </View>
    <View style={styles.fix}>
      <AdaptedButton
        handleClick={handleButtonClick}
        field={'current_products'}
        fieldValue={'Gel Cleanser'}
        selected={selectedValues.includes('Gel Cleanser')}
      />
    </View>
  </View>

  <View style={styles.buttonRow}>
    <View style={styles.fix}>
      <AdaptedButton
        handleClick={handleButtonClick}
        field={'current_products'}
        fieldValue={'Foam cleanser'}
        selected={selectedValues.includes('Foam cleanser')}
      />
    </View>
    <View style={styles.fix}>
      <AdaptedButton
        handleClick={handleButtonClick}
        field={'current_products'}
        fieldValue={'Toner'}
        selected={selectedValues.includes('Toner')}
      />
    </View>
  </View>


  <View style={styles.buttonRow}>
    <View style={styles.fix}>
      <AdaptedButton
        handleClick={handleButtonClick}
        field={'current_products'}
        fieldValue={'Chemical exfoliant'}
        selected={selectedValues.includes('Chemical exfoliant')}
      />
    </View>
    <View style={styles.fix}>
      <AdaptedButton
        handleClick={handleButtonClick}
        field={'current_products'}
        fieldValue={'Physical exfoliant'}
        selected={selectedValues.includes('Physical exfoliant')}
      />
    </View>
  </View>


  <View style={styles.buttonRow}>
    <View style={styles.fix}>
      <AdaptedButton
        handleClick={handleButtonClick}
        field={'current_products'}
        fieldValue={'Essence'}
        selected={selectedValues.includes('Essence')}
      />
    </View>
    <View style={styles.fix}>
      <AdaptedButton
        handleClick={handleButtonClick}
        field={'current_products'}
        fieldValue={'Ampoule'}
        selected={selectedValues.includes('Ampoule')}
      />
    </View>
  </View>
  <View style={styles.buttonRow}>
    <View style={styles.fix}>
      <AdaptedButton
        handleClick={handleButtonClick}
        field={'current_products'}
        fieldValue={'Serum'}
        selected={selectedValues.includes('Serum')}
      />
    </View>
    <View style={styles.fix}>
      <AdaptedButton
        handleClick={handleButtonClick}
        field={'current_products'}
        fieldValue={'Masks'}
        selected={selectedValues.includes('Masks')}
      />
    </View>
  </View>
  <View style={styles.buttonRow}>
    <View style={styles.fix}>
      <AdaptedButton
        handleClick={handleButtonClick}
        field={'current_products'}
        fieldValue={'Lotion'}
        selected={selectedValues.includes('Lotion')}
      />
    </View>
    <View style={styles.fix}>
      <AdaptedButton
        handleClick={handleButtonClick}
        field={'current_products'}
        fieldValue={'Creams'}
        selected={selectedValues.includes('Creams')}
      />
    </View>
  </View>
  <View style={styles.buttonRow}>
    <View style={styles.fix}>
      <AdaptedButton
        handleClick={handleButtonClick}
        field={'current_products'}
        fieldValue={'SPF'}
        selected={selectedValues.includes('SPF')}
      />
    </View>
    <View style={styles.fix}>
      <AdaptedButton
        handleClick={handleButtonClick}
        field={'current_products'}
        fieldValue={'Moisturizer'}
        selected={selectedValues.includes('Moisturizer')}
      />
    </View>
  </View>
</View>
  );
}


const styles = StyleSheet.create({
  buttonRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    justifyContent: 'center',
    //marginBottom: 10,
  },
  center: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    //margin: 5
  },
  fix: {
    width: '48%',
    margin: 2,
  }
});